import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideUp = keyframes`from { transform: translateY(24px); opacity: 0; } to { transform: translateY(0); opacity: 1; }`;

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.82);
    backdrop-filter: blur(8px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
    animation: ${fadeIn} 0.3s ease;
    padding: 20px;
    box-sizing: border-box;
`;

export const ModalContent = styled.div`
    background: #1e1e1e;
    border-radius: 20px;
    width: 100%;
    max-width: 920px;
    height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.6);
    animation: ${slideUp} 0.4s ease-out;
    border: 1px solid rgba(255, 255, 255, 0.07);
    overflow: hidden;
`;

export const FecharModal = styled.div`
    padding: 20px 30px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    background: #242424;

    button {
        background: transparent;
        border: none;
        color: #aaa;
        font-size: 20px;
        cursor: pointer;
        transition: color 0.2s;
        display: flex;
        align-items: center;
        &:hover { color: #ff4d4d; }
    }
`;

export const ModalTitle = styled.h2`
    margin: 0;
    color: #d4af37;
    font-size: 1.2rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
`;

export const Searching = styled.div`
    padding: 25px 30px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    gap: 14px;

    p {
        margin: 0;
        color: #aaa;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 700;
        letter-spacing: 0.05em;
    }

    .inputBoxSearch {
        display: flex;
        gap: 10px;
        flex-shrink: 0;

        input {
            flex-grow: 1;
            height: 48px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            background: rgba(0, 0, 0, 0.3);
            padding: 0 18px;
            color: #fff;
            border-radius: 12px;
            font-size: 0.95rem;
            transition: border-color 0.2s;
            &:focus {
                outline: none;
                border-color: #d4af37;
            }
            &::placeholder { color: #555; }
        }
        button {
            height: 48px;
            padding: 0 24px;
            border: none;
            background: #d4af37;
            color: #111;
            font-weight: 700;
            font-size: 0.85rem;
            letter-spacing: 0.04em;
            cursor: pointer;
            border-radius: 12px;
            transition: background 0.2s;
            &:hover { background: #c5a02d; }
        }
    }
`;

export const SearchedClients = styled.div`
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
    background: #181818;

    .columns, .row, .rowSelected {
        display: grid;
        grid-template-columns: 1fr 3fr 2fr 2fr 2fr;
        padding: 12px 18px;
        align-items: center;
    }
    .columns {
        font-size: 0.72rem;
        font-weight: 700;
        letter-spacing: 0.06em;
        color: #888;
        text-transform: uppercase;
        background: #1e1e1e;
        border-bottom: 1px solid rgba(212, 175, 55, 0.3);
        flex-shrink: 0;
    }
    .tabelona {
        overflow-y: auto;
        flex-grow: 1;
    }
    .row {
        cursor: pointer;
        transition: background 0.15s;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        color: #ccc;
        font-size: 0.9rem;
        &:hover { background: rgba(212, 175, 55, 0.07); color: #fff; }
        &:last-child { border-bottom: none; }
    }
    .rowSelected {
        background: linear-gradient(135deg, #d4af37, #c5a02d);
        color: #111;
        font-weight: 700;
        border-radius: 10px;
        margin: 10px;
        grid-template-columns: 1fr 3fr 2fr 2fr 2fr auto;
        font-size: 0.9rem;
    }
`;

export const SacarDoSelecionado = styled.div`
    padding: 20px 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    background: #242424;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    flex-shrink: 0;

    .titulo {
        color: #aaa;
        font-weight: 700;
        font-size: 0.78rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;
    }
    .inputSacar {
        height: 50px;
        background: rgba(0, 0, 0, 0.4);
        border: 1px solid rgba(255, 255, 255, 0.12);
        color: #fff;
        padding: 0 18px;
        border-radius: 12px;
        width: 160px;
        font-size: 1.3rem;
        font-weight: 600;
        text-align: center;
        transition: border-color 0.2s;
        &:focus {
            outline: none;
            border-color: #d4af37;
        }
    }
    .inputRepurchaseId {
        height: 50px;
        background: rgba(0, 0, 0, 0.4);
        border: 1px solid rgba(212, 175, 55, 0.4);
        color: #fff;
        padding: 0 18px;
        border-radius: 12px;
        width: 140px;
        font-size: 1rem;
        text-align: center;
        transition: border-color 0.2s;
        &:focus {
            outline: none;
            border-color: #d4af37;
        }
        &::placeholder { color: #555; font-size: 0.8rem; }
    }
    .buttonSacar {
        height: 50px;
        border: none;
        background: #27ae60;
        color: #fff;
        padding: 0 28px;
        border-radius: 12px;
        cursor: pointer;
        font-weight: 700;
        font-size: 0.9rem;
        letter-spacing: 0.04em;
        transition: background 0.2s, transform 0.2s;
        &:hover {
            background: #219a52;
            transform: translateY(-1px);
        }
    }
`;

export const RepurchaseToggle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: #aaa;
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    user-select: none;
    transition: color 0.2s;
    &:hover { color: #d4af37; }
`;

export const RepurchaseCheckbox = styled.div`
    width: 18px;
    height: 18px;
    border-radius: 5px;
    border: 2px solid ${(props) => (props.checked ? "#d4af37" : "rgba(255,255,255,0.2)")};
    background: ${(props) => (props.checked ? "#d4af37" : "transparent")};
    transition: all 0.2s;
    flex-shrink: 0;
`;

export const SearchClient = styled.div``;
export const SelecionarClienteBox = styled.div``;
export const Cliente = styled.div``;
export const ClienteSelecionado = styled.div``;
export const ClienteInfo = styled.div``;
export const ButtonSaque = styled.div``;
